/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';

import { companyContextsSelectors } from '../../../../../app/resource/company-contexts/company-contexts.selectors';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { ICompanyContextItemProps } from './types';

export const CompanyContextItem: FunctionComponent<ICompanyContextItemProps> = ({ companyContextId, color }) => {
  const companyContext = useSelectWithParams(companyContextsSelectors.selectResourceById, companyContextId);
  const history = useHistory();

  if (!companyContext || companyContext.title === '') {
    return null;
  }

  return (
    <div className="list-item h35 mb-0 aic jcc border-bottom">
      <a
        className="link flex aic"
        style={{ color: color }}
        onClick={() => history.push(`/agency-tools/context/${companyContextId}`)}
      >
        {companyContext.title}
      </a>
    </div>
  );
};
